import React from "react";
import Modal from "../../../../../components/Common/Modal/Modal";
import classes from "./TopicShotClassPreviewData.module.scss";
import { FormattedMessage } from "react-intl";

const TopicShotClassPreviewData = ({
  previewSelectedDataModalOpen,
  setPreviewSelectedDataModalOpen,
  topicShotclassDataByID,
  previewCreator,
}) => {
  return (
    <Modal
      isOpen={previewSelectedDataModalOpen}
      heading={topicShotclassDataByID?.Name}
      toggle={() => setPreviewSelectedDataModalOpen(false)}
      width={"80"}
    >
      <div className={classes.previewModalMain}>
        <div className={classes.previewModalLeftData}>
          <table>
            <tr>
              <th><FormattedMessage id="NAME_TEXT" /></th>
            </tr>
            {topicShotclassDataByID?.TopicCourseAssociations?.map((data) => {
              return (
                <tr key={data?.Value}>
                  <td>{data?.Name}</td>
                </tr>
              );
            })}
          </table>
        </div>
        <div className={classes.previewModalRightData}>
          <div className={classes.createdByNameAndOn}>
            <div className={classes.createdBy}>
              <FormattedMessage id="CREATED_BY" /> <div className={classes.value}>{previewCreator}</div>
            </div>
            <div className={classes.createdOn}>
              <FormattedMessage id="CREATED_ON_TXT" />
              <div className={classes.value}>
                {topicShotclassDataByID?.CreatedOn}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default TopicShotClassPreviewData;
